var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFacebookMessenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "leftmenu_x2F_contactus_x2F_icon-messenger_00000085949809056404977260000012641132886180434872_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -179.9066,
    cy: -373.5677,
    r: 0.03437231,
    gradientTransform: "matrix(800 0 0 800 143932 298882.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0099FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#A033FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#FF5280"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7061"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,3C8,3,2.5,8.2,2.5,15.1c0,3.6,1.5,6.8,3.9,9c0.2,0.2,0.3,0.4,0.3,0.7L6.8,27c0,0.6,0.5,1,1,1 c0.1,0,0.3,0,0.4-0.1l2.5-1.1c0.2-0.1,0.4-0.1,0.7,0c1.1,0.3,2.4,0.5,3.6,0.5c7,0,12.5-5.2,12.5-12.1S22,3,15,3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,18.7l3.7-5.8c0.6-0.9,1.7-1.1,2.6-0.6c0,0,0.1,0.1,0.1,0.1l2.9,2.2c0.3,0.2,0.6,0.2,0.9,0l3.9-3 c0.5-0.4,1.2,0.2,0.9,0.8l-3.7,5.8c-0.6,0.9-1.7,1.1-2.6,0.6c0,0-0.1-0.1-0.1-0.1l-2.9-2.2c-0.3-0.2-0.6-0.2-0.9,0l-3.9,3 C7.8,19.9,7.1,19.2,7.5,18.7L7.5,18.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebookMessenger);
export default __webpack_public_path__ + "static/media/icon-facebook-messenger.9e8b4a9e24470d1ad68e40a03f20c4c6.svg";
export { ForwardRef as ReactComponent };